import "babel-polyfill";
import React from "react";
import JssProvider from "react-jss/lib/JssProvider";
import CssBaseline from "@material-ui/core/CssBaseline";
import { create } from "jss";
import { withStyles } from "jss/lib/types";
// @ts-ignore
import { createGenerateClassName, jssPreset } from "@material-ui/core/styles";
import { ApolloProvider } from "@apollo/client";

import { RecoilRoot } from "recoil";
import AppProvider from "config/appProvider";
import CommonProvider from "config/commonProvider";
import TableOptionsProvider from "config/tableOptionsProvider";
import client from "api/graphQL";
import { Routes } from "./Routes";

const generateClassName = createGenerateClassName();
const jss: withStyles = create(jssPreset());

jss.options.insertionPoint = document.getElementById("jss-insertion-point");

const App: React.FC = () => (
  <JssProvider jss={jss} generateClassName={generateClassName}>
    <CssBaseline>
      <ApolloProvider client={client}>
        <RecoilRoot>
          <AppProvider>
            <CommonProvider>
              <TableOptionsProvider>
                <Routes />
              </TableOptionsProvider>
            </CommonProvider>
          </AppProvider>
        </RecoilRoot>
      </ApolloProvider>
    </CssBaseline>
  </JssProvider>
);

export default App;
